<template>
  <el-card
    style="height: 100%; width: 100%"
    body-class="flex flex-col gap-4"
    :body-style="{
      height: '100%',
      width: '100%',
    }"
    shadow="always">
    <OptimizationDetailsTable
      v-if="application"
      :application="application"
      :all-software-licenses="allSoftwareLicenses" />
  </el-card>
</template>

<script setup lang="ts">
  import { computed, watch } from 'vue'
  import { SoftwareLicense } from '@/client'
  import { useApplicationDetailsStore } from '@/stores/ApplicationDetailsView.store'
  import { useRoute } from 'vue-router'

  const route = useRoute()
  const applicationDetailsStore = useApplicationDetailsStore()

  const applicationIdParam = computed(() => {
    const param = route.params.id
    return Array.isArray(param) ? param[0] : (param as string)
  })

  watch(
    applicationIdParam,
    (id) => {
      if (id) {
        applicationDetailsStore.loadApplicationDetails(id)
      }
    },
    { immediate: true }
  )

  const application = computed(() => applicationDetailsStore.application)
  const allSoftwareLicenses = computed<SoftwareLicense[]>(
    () => applicationDetailsStore.licences
  )
</script>
